import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { useMutation, useQueryClient } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';

export function useClearNotification(type?: 'ALL' | 'UNREAD' | 'CONTRACT' | 'ACTIVE_SESSION_SECURITY') {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await $api.post(`${endPoints.POST_CLEAR_NOTIFICATION}?id=${id}`);

      return res.data;
    },
    onSuccess: () => {
      qc.fetchQuery([queryNames.NOTIFICATION_ME, type]);
    },
    onError: baseErrorHandler
  });
}
